import * as React from "react";
import { AnchoredPanel, AnchoredPanelProps } from "../Panel/AnchoredPanel";
import { DetailViews, DetailViewsProps } from "./DetailViews";

export interface DetailViewsPanelProps extends DetailViewsProps,
  Pick<AnchoredPanelProps,
  "anchorId" | "componentRef" | "title" | "status" | "icon" | "subTitle" | "onClose" | "isOpen"> {
}

/**
 * The DetailsViewsPanel handle rendering of AnchoredPanel and DetailViews directly.
 */
export const DetailViewsPanel = ({
  anchorId,
  componentRef,
  title,
  status,
  subTitle,
  isOpen,
  onClose,
  menu,
  menuFixed,
  views,
  onMenuItemSelect,
  activeViewId,
  icon,
}: DetailViewsPanelProps): JSX.Element => (
  <AnchoredPanel
    anchorId={anchorId}
    componentRef={componentRef}
    title={title}
    status={status}
    subTitle={subTitle}
    onClose={onClose}
    icon={icon}
    isOpen={isOpen}
  >
    <DetailViews
      menu={menu}
      menuFixed={menuFixed}
      views={views}
      activeViewId={activeViewId}
      onMenuItemSelect={onMenuItemSelect}
    />
  </AnchoredPanel>
);
